import { Children, type ReactNode } from 'react';

/**
 * Determines whether React children are considered "empty" or have no content.
 *
 * @param {ReactNode} children - The React children to evaluate.
 * @returns {boolean} Returns `true` if the children are considered empty, `false` otherwise.
 */
export const isChildrenEmpty = (children: ReactNode): boolean =>
  Children.count(children) <= 0 || (typeof children === 'string' && children === '');
